import type { OwnerWebmailSession } from '@/features/platform/api';

const OWNER_WEBMAIL_ORIGIN = 'https://mail.niftyhosting.co.za';

export function beginOwnerInboxHandoff(): Window | null {
  const inboxWindow = window.open('', '_blank');
  if (!inboxWindow) return null;
  inboxWindow.document.title = 'Opening inbox…';
  inboxWindow.document.body.textContent = 'Opening the read-only inbox…';
  return inboxWindow;
}

export function submitOwnerInboxHandoff(inboxWindow: Window, session: OwnerWebmailSession): void {
  if (inboxWindow.closed) throw new Error('The inbox tab was closed before sign-in completed.');
  const action = new URL(session.actionUrl);
  if (action.origin !== OWNER_WEBMAIL_ORIGIN) throw new Error('The inbox destination is not trusted.');

  const form = inboxWindow.document.createElement('form');
  form.method = 'POST';
  form.action = action.toString();
  form.target = '_self';
  const token = inboxWindow.document.createElement('input');
  token.type = 'hidden';
  token.name = 'token';
  token.value = session.token;
  form.appendChild(token);
  inboxWindow.document.body.replaceChildren(form);
  inboxWindow.opener = null;
  form.submit();
}
